/** @module CookieUtils */


function getCookies () {
  const cookies = document.cookie.split('; ')
  const cookieObj = {}
  cookies.forEach(cookie => {
    const [key, value] = cookie.split('=')
    cookieObj[key] = value
  })
  return cookieObj
}
getCookies()
function clearAllCookies () {
  const cookies = getCookies()
  for (const cookie in cookies) {
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  }
}

/**
 * Utilities for cookie (storage) related operations
 * @property {Function} getCookie Get cookie value with supplied key
 * @property {Function} setCookie Set cookie with key and value
 * 
 * @author Tin Ley Ter <leyter.tin@orbitmy.com>
 * @since 2022/07/20
 */
const CookieUtils = {
  /**
   * Get cookie value with supplied key
   * @param {String} key Name of cookie
   * @return {String | null}
   * - Returns `String` when cookie match is found
   * - Returns `null` if no matches is found
   */
  getCookie (key) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${key}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  },
  /**
   * Set cookie with key and value
   * @param {String} key Name of cookie to set
   * @param {String} value Value of cookie to set
   */
  setCookie (key, value) {
    document.cookie = key + '=' + value + ';path=/'
  },
  getCookies,
  clearAllCookies
}
export default CookieUtils
